export const eventHandlers = {
  MENU_PAGE_VIEW: 'MENU_PAGE_HIT',
};
